import QueryString from 'utils/query_string';

class AutoFillByQueryString {
  static sanitizeKey(key) {
    return key.replace('[', '\\[').replace(']', '\\]');
  }

  static sanitizeValue(value) {
    return value.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\\\$&');
  }

  static fillInputs($form, key, value) {
    key = AutoFillByQueryString.sanitizeKey(key);
    const $input = $(`[name="${key}"]`, $form)
      .not('input[type="checkbox"], input[type="radio"], .q-select-input[data-ajax] input, [data-autofill="false"]');

    if (!$input.length) return;
    if ($input.is('select')) {
      $input.val(value);
      $input.find(`option[value="${AutoFillByQueryString.sanitizeValue(value)}"]`)
        .prop('selected', true)
        .trigger('change');
    } else {
      $input.val(value);
    }

    $input.trigger('change');
  }

  static fillCheckInputs($form, key, value) {
    key = AutoFillByQueryString.sanitizeKey(key);
    const apply = function (value) {
      $(`[name="${key}"]`, $form)
        .not('[data-autofill="false"]')
        .each((i, el) => {
          const $input = $(el);

          if (($input.is(':checkbox') || $input.is(':radio')) && value === $input.val()) {
            $input.prop('checked', true)
              .attr('checked', true)
              .trigger('change');
          }
        });
    };

    if (Array.isArray(value)) {
      $(value).each((i, val) => {
        apply(val);
      });
    } else {
      apply(value);
    }
  }

  static fillAjaxSelects($form, key, value) {
    key = AutoFillByQueryString.sanitizeKey(key);
    key = key.replace('\\[', '');
    key = key.replace('\\]', '');

    const $ajaxSelects = $(`.q-select-input[data-ajax="true"][data-name="${key}"]:not([data-autofill="false"])`, $form);

    if ($ajaxSelects.length) {
      $ajaxSelects.each((i, select) => {
        $(select).qselect('setValue', value);
      });
    }
  }
}

(function ($) {
  'use strict';

  if (!$.fn.autoFillByQueryString) {
    $.fn.autoFillByQueryString = function (qs = null) {
      const $form = this;
      qs = $form.data('current-params') || qs;
      const data = QueryString.getQueryStringData(qs);

      Object.keys(data).forEach(function (key) {
        const value = data[key];
        AutoFillByQueryString.fillInputs($form, key, value);
        AutoFillByQueryString.fillCheckInputs($form, key, value);
        AutoFillByQueryString.fillAjaxSelects($form, key, value);
      });

      EventManager.publish('autofillByQueryString.applied', data);

      return $form;
    };
  }
})(jQuery);

export default AutoFillByQueryString;
